<template>
  <div>
      <div class="container mx-auto">
<!--         <vx-card style="max-height: 285px">-->
<!--           <div v-if="is_skeleton">-->
<!--             <ASkeleton active/>-->
<!--           </div>-->
<!--           <div v-else>-->
<!--             <h3 class="mb-10">Details</h3>-->
<!--             <a-descriptions :column="1">-->
<!--               <a-descriptions-item v-if="bills && bills.to_contact" label="Client">-->
<!--                 {{ bills.to_contact.person ? `${bills.to_contact.person.first_name } ${bills.to_contact.person.last_name}` : `${bills.to_contact.company.name}` }}-->
<!--               </a-descriptions-item>-->
<!--               <a-descriptions-item label="Matter(s)">-->
<!--                 <ATag color="#3A3DBE" v-for="matter in bills.matters">-->
<!--                   {{ matter.title }}-->
<!--                 </ATag>-->
<!--               </a-descriptions-item>-->
<!--             </a-descriptions>-->
<!--             <a-divider/>-->
<!--             <a-descriptions>-->
<!--               <a-descriptions-item label="Due date">-->
<!--                 {{ bills.due_date }}-->
<!--               </a-descriptions-item>-->
<!--               <a-descriptions-item label="Issue date">-->
<!--                 {{ bills.issue_date }}-->
<!--               </a-descriptions-item>-->
<!--               <a-descriptions-item label="Status">-->
<!--                 {{ statusBill(bills.status) }}-->
<!--               </a-descriptions-item>-->
<!--               <a-descriptions-item label="Total amount">-->
<!--                 {{ bills.total_amount }}-->
<!--               </a-descriptions-item>-->
<!--               <a-descriptions-item label="Payed amount">-->
<!--                 {{ bills.payed_amount }}-->
<!--               </a-descriptions-item>-->
<!--             </a-descriptions>-->
<!--           </div>-->
<!--         </vx-card>-->
          <vx-card :class="is_skeleton ? '': 'card-template-dashboard'">
              <div v-if="is_skeleton">
                <ASkeleton v-for="n in 10" avatar active />
              </div>
              <div v-else>
                <ACard class="temp-head" :headStyle="{ padding: 0 }">
                  <template slot="title">
                    <template v-if="which_bill_temp(1)">
                      <h1 class="title-temp-1 font-semibold title-invoice">
                        <template v-if="invoice_html && invoice_html.data">
                          {{ (invoice_html.record.type === 1 ? 'Invoice ' : 'Trust Fund Request ') + invoice_html.record.factor_no }}
                        </template>
                      </h1>
                    </template>
                    <template v-if="which_bill_temp(2)">
                      <div class="flex header-modal-bill">
                        <div v-if="invoice_html && invoice_html.record" class="flex flex-col justify-center pl-8 color-amount-due space-y-4 w-2/3" style="background: #41438d">
                          <div class="text-3xl">{{ (invoice_html.record.type === 1 ? 'Invoice ' : 'Trust Fund Request ') + invoice_html.record.factor_no }}</div>
                          <small>
                            {{ invoice_html.record.to_contact.person ? `${invoice_html.record.to_contact.person.first_name} ${invoice_html.record.to_contact.person.last_name}` : invoice_html.record.to_contact.company.name }}
                          </small>
                        </div>
                        <div class="flex flex-col justify-center items-center w-1/3 color-amount-due" style="background: #393a87 ">
                          <small>Amount Due</small>
                          <div class="text-3xl" v-if="invoice_html && invoice_html.record">
                            <!-- {{ 'RM' + (invoice_html.record.total_amount - invoice_html.record.payed_amount).toFixed(2) || '__' }} -->
                            <!-- {{ currencySymbol + (invoice_html.record.total_amount).toFixed(2) || '__' }} -->
                            {{ currencySymbol + amountDue }}
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-if="which_bill_temp(3)">
<!--                      temp-header-3-->
                      <div class="temp-header-3 title-invoice">
                        <template v-if="invoice_html && invoice_html.data">
                          {{ (invoice_html.record.type === 1 ? 'Invoice ' : 'Trust Fund Request ') + invoice_html.record.factor_no }}
                        </template>
                      </div>
                    </template>
                  </template>
                  <template v-if="invoice_html && Object.values(template_data).length">
                    <a-button
                      v-if="approveNotDueDate(invoice_html.record)"
                      type="primary"
                      class="bnt-payment-bill mb-2"
                      @click="goToRecordPaymentOrSendFund(invoice_html.record)"
                    >
                      Record Payment
                    </a-button>
                    <template v-if="template_data.templates">
                      <template v-if="template_data.templates.template === 1">
                        <TemplateOne 
                          :items="invoice_html"
                          :setting="template_data"
                          @finalClose="finalClose"
                          @amountDueChanged="handleAmountDueChanged"
                        />
                      </template>
                      <template v-if="template_data.templates.template === 2">
                        <TemplateTwo 
                          :items="invoice_html"
                          :setting="template_data"
                          @amountDueChanged="handleAmountDueChanged"
                        />
                      </template>
                      <template v-if="template_data.templates.template === 3">
                        <TemplateThree 
                          :items="invoice_html"
                          :setting="template_data"
                          @amountDueChanged="handleAmountDueChanged"
                        />
                      </template>
                    </template>
                  </template>
                </ACard>
              </div>
          </vx-card>
      </div>
  </div>
</template>

<script>
import axios from "@/axios";
import Template from '../template/Template'
import Template2 from '../template/Template2'
import Template3 from '../template/Template3'
import Mixin from '../mixin/mixin'
import moment from "moment";

export default {
  name: "BillingDashboard",

  mixins:[Mixin],

  components:{
    TemplateOne  :Template,
    TemplateTwo  :Template2,
    TemplateThree:Template3,
  },
  
  data() {
    return {
      is_skeleton  : false,
      bills        : {},
      invoice_html : {},
      template_data: {},
      amountDue    : '0.00',
    }
  },
  
  methods: {
    finalClose(val){
      if (val) {
        this.$router.push('/billing')
      }
    },

    async getOneBill() {
      try {
        this.is_skeleton = true
        const bill_id = this.$route.params.id
        const {data}  = await axios.get(`/billing/${bill_id}/`)
        this.bills    = data
      } catch (e) {
        this.$router.back()
        this.$message.error('Server Error')
        throw new Error(e)
      } finally {
        this.is_skeleton = false
      }
    },
    async InvoiceDisplay(){
    },
    statusBill(sts){
      if(sts === 1)
        return 'Draft'
      else if(sts === 2)
        return 'Approve'
      else if(sts === 3)
        return 'Unpaid'
      else if(sts === 4)
        return 'Paid'
    },

    // Record Payment Methods
    approveNotDueDate(record){
      if (record)
        return record.status === 2 && (moment().format('YYYY-MM-DD') >= moment(record.due_date).format('YYYY-MM-DD'))
    },
    goToRecordPaymentOrSendFund(record,option = undefined){
      option ? this.$router.push({ path: '/billing/request-fund', query: { send_fund: record.id }}):
        this.$router.push({ path: '/billing/record-payment', query: { client_id: record.to_contact.id,type: record.type }})
    },

    handleAmountDueChanged(amount) {
      this.amountDue = amount
    },
  },
  computed: {
    currencySymbol() {
      return localStorage.getItem('currency_symbol')
    },
  },
  async mounted() {
    await this.getOneBill()

    // await this.InvoiceDisplay()
    try {
      this.is_skeleton = true
      const res = await axios.get(`/billing/${this.bills.id}/data/`)
      const { data } = await axios.get('/setting/firm/')
      const { data: taxData } = await axios.get(`billing/${this.bills.id}/tax/`)
      const { data: discountData } = await axios.get(`billing/${this.bills.id}/discount/`)
      if (Object.values(data).length) {
        this.template_data = {
          discount_data: discountData,
          matter_taxes: taxData,
          accounts: data.setting ? data.setting.accounts : undefined,
          tax: data.setting ? { ...data.setting.tax } : undefined,
          templates: data.setting.templates === undefined ? {template: 1 ,avatar: null,description: null} : data.setting.templates
        }
      }
      this.invoice_html = {data: res.data, record: this.bills}
    } catch (e) {
      this.$message.error('Error receiving data')
    } finally {
      this.is_skeleton  = false
    }
  }
}
</script>

<style>
  @import "../style/style.css";
  [dir] .ant-tag{
    border-radius: 3px !important;
  }
  .temp-head .ant-card-head-title {
    padding: 0;
  }
  .temp-head .ant-card-head-wrapper{
    width: 100%;
  }
  .card-template-dashboard .vx-card__body{
    padding: 0 !important;
  }
</style>
